import React from 'react';

import styled from '@emotion/styled';

import Img from '../Img/Img';

interface IEmptyableCard {
  label: string | React.ReactNode;
  children?: React.ReactNode;
  emptyViewNote: string | React.ReactNode; //| any;
  isEmpty: boolean;
  className?: string;
}
const EmptyableCardViewHealth: React.FC<IEmptyableCard> = ({
  label,
  emptyViewNote,
  children,
  isEmpty,
  className,
}) => {
  return (
    <Container>
      <Label>
        <Label>{label}</Label>
      </Label>
      <ContentContainer className={className}>
        {!isEmpty ? (
          <EmptyWrapper>
            <EmptyWrapperImage>
              <Img src="/static/gif/formholder.gif" alt="no content" />
            </EmptyWrapperImage>
            <P>{emptyViewNote}</P>
          </EmptyWrapper>
        ) : (
          <NonEmptyContentWrapper className={className}>
            {children}
          </NonEmptyContentWrapper>
        )}
      </ContentContainer>
    </Container>
  );
};

export default EmptyableCardViewHealth;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  // max-width: 50rem;

  & .applicantCard {
    display: flex;
    flex-direction: row;
  }
`;

const Label = styled.div`
  display: flex;
  color: ${({ theme }) => theme.palette.blackBlack3};
  font-weight: 400;
  font-size: 1.125rem;
`;

// const Link = styled.a`
//   text-decoration: none;
//   color: #2857d1;
//   // border: 1px solid blue;
// `;

const ContentContainer = styled.div`
  background-color: white;
  border-radius: 0.625rem;
  display: flex;
  flex-direction: column;
  height: 27.875rem;
  // border: 1px solid ${({ theme }) => theme.palette.greyGrey3};
  box-shadow: 0px 20px 26px 0px #bab6b629;
  &.biggerPadding {
    height: fit-content;
  }
`;

const EmptyWrapper = styled.div`
  padding: 5rem;
  margin: auto;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const EmptyWrapperImage = styled.div`
  width: 12.5rem;
  height: 12.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const NonEmptyContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  //   padding: 1rem;
  overflow-y: auto;

  &.biggerPadding {
    padding: 2rem;
  }
`;

const P = styled.p`
  text-align: center;
  display: flex;
  align-items: center;
  max-width: 20rem;
`;
